<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-form>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"> {{$t('Ticket-General-Parameters')}} </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip bottom v-if="parametreYuklendi">
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>

                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>

            </v-toolbar>

          </v-flex>

          <v-flex xs12 sm6 md3 pa-1>
            <v-flex xs12 sm12 md12>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>

                      <v-flex xs12 sm12 md12>
                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium ">{{$t("tab_general")}}</span>
                          </v-card-title>
                        </v-card>
                      </v-flex>
 <v-switch :label="$t('Calculate-Service-Charge/Discount-When-Amount-Changes')"
                        v-model="BiletParametre.ParmetreIskonto.TutarDegisinceIskontoHesapla" hide-details=""></v-switch>
                      <v-switch :label="$t('Show-Service-Difference-Discount')"
                        v-model="BiletParametre.ParmetreIskonto.ServisFarkiIskontoGoster" hide-details=""></v-switch>

                      <v-switch :label="$t('Assign-Invoice-No-Automatically')" v-model="BiletParametre.ParametreGenel.FaturaNoOtomatik"
                        hide-details=""></v-switch>
                      <v-switch :label="$t('Assign-Ticket-Date-Currency')" hide-details=""
                        v-model="BiletParametre.ParametreGenel.KurTarihiSatisTarihiKullan"></v-switch>
                      <v-switch :label="$t('Use-Foreign-Sales-Currency-Invoice')" hide-details=""
                        v-model="BiletParametre.ParametreGenel.SerbestFaturaDovizSatisKuru"></v-switch>

                      <v-switch :label="$t('Invoice-Refund-Tickets')" hide-details=""
                        v-model="BiletParametre.ParametreGenel.IadeBiletFaturala"></v-switch>

                      <v-switch :label="$t('Separate-Airline-Accounts-by-Company')" hide-details=""
                        v-model="BiletParametre.ParametreGenel.HavaYoluHesapSirketeGore"></v-switch>
                      <v-switch :label="$t('Dontt-Reset-Service-Airline-Amount')" hide-details=""
                        v-model="BiletParametre.ParametreGenel.HyTutarServisSifirlama"></v-switch>

                      <v-switch :label="$t('Section-Code-Required')" hide-details=""
                        v-model="BiletParametre.ParametreDiger.BolumKoduZorunlu"></v-switch>
                      <v-switch :label="$t('Write-Pcs-on-Single-Line-Invoice')" hide-details=""
                        v-model="BiletParametre.ParametreDiger.TekSatirFaturaAdet"></v-switch>
                        <v-switch
                                  label="Bilette Servis Tutarını Yuvarlama"
                                  v-model="BiletParametre.ParametreGenel.ServisYuvarlamaYok"
                                  hide-details="">
                        </v-switch>
                        <v-switch
                                 label="THY Aktarımda TKM Servis Tutarını Yaz"
                                 v-model="BiletParametre.ParametreGenel.ThyTkmServisTutarYaz"
                                 hide-details="">
                        </v-switch>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


            <v-flex xs12 sm12 md12>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 md12>
                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium ">{{ $t('Maturity') }} </span>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                      <v-switch :label="$t('Dont-Subtract-Holidays-Payment')" hide-details=""
                        v-model="BiletParametre.ParametreVade.OdemeVadeTatilGunu"></v-switch>
                      <v-switch :label="$t('Use-Return-Date-Return-Term')" hide-details=""
                        v-model="BiletParametre.ParametreVade.IadeVadeIadeTarihiKullan"></v-switch>
                      <v-switch :label="$t('Calculate-Return-Term')" v-model="BiletParametre.ParametreVade.IadeVadeHesapla"
                        hide-details="">
                      </v-switch>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-flex>

          <v-flex xs12 sm6 md3 pa-1>
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">{{ $t('Current') }}</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch :label="$t('Amount-Commission-Airline-Payable')" hide-details=""
                      v-model="BiletParametre.ParametreCari.HavayoluKomisyonDusulememisTutar"></v-switch>

                    <v-switch :label="$t('Current-Transaction-Connected-Tickets')" hide-details=""
                      v-model="BiletParametre.ParametreCari.BaglantiliBiletCariHareketOlustur"></v-switch>

                    <v-switch :label="$t('Dont-Reset-Balance-Cash-Tickets')"
                      v-model="BiletParametre.ParametreCari.PesinBiletBakiyeSifir" hide-details=""></v-switch>
                    <v-switch :label="$t('Dont-Add-Discount-Current-Account')"
                      v-model="BiletParametre.ParametreCari.IskontoCariyeAtma" hide-details=""></v-switch>
                    <v-switch :label="$t('Ticketing-Airline-Current-Account')" hide-details=""
                      v-model="BiletParametre.ParametreCari.HavayoluCariKesimTarih"></v-switch>
                    <v-switch  :label="$t('Ticket-Amount-Current-Account')" hide-details=""
                      v-model="BiletParametre.ParametreCari.BiletTutariServisli"></v-switch>
                    <v-switch :label="$t('Ticket-Amount-Current Account-Variable')" hide-details=""
                      v-model="BiletParametre.ParametreCari.BiletTutariDegiskenli"></v-switch>
                      <v-switch label="Pegasus Blt. Aktarım döviz tarihini bir gün önce al" hide-details=""
                      v-model="BiletParametre.ParametreCari.GetYesterdayCurrency"></v-switch>
                      <v-switch  :label="$t('OfficeId-Cari-Matching')" hide-details=""
                        v-model="BiletRaporParametre.ParametreAktarim.OfficeIdCariEslestirme"></v-switch>
                    <v-flex pt-2 xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium "> {{ $t('VAT') }} </span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch :label="$t('Separate-VAT-on-the-Invoice')" hide-details=""
                      v-model="BiletParametre.ParametreKdv.FaturaKdvAyir"></v-switch>
                    <v-switch :label="$t('Separate-VAT-on-the-Receipt')" hide-details=""
                      v-model="BiletParametre.ParametreKdv.DekontKdvAyir"></v-switch>
                    <v-switch :label="$t('Separate-VAT-in-PTA-Amount')" v-model="BiletParametre.ParametreKdv.PtaTutarKdvAyir"
                      hide-details="">
                    </v-switch>
                    <v-switch :label="$t('Round-Up-VAT-Amounts')"
                      v-model="BiletParametre.ParametreKdv.KdvYukariYuvarla" hide-details="">
                    </v-switch>
                    
                    <v-switch :label="$t('Calculate VAT from the total amount on the invoice.')"
                      v-model="BiletParametre.ParametreKdv.DipdenKdvHesapla" hide-details="">
                    </v-switch>
                    <v-switch :label="$t('VAT should be separated from international flight tickets in variable area.')"
                      v-model="VergiParametre.ReserveDisHatKdv" hide-details="">
                    </v-switch>
                  

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>


          <v-flex xs12 sm6 md3>
            <v-flex xs12 sm12 md12 pa-1>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>

                      <v-flex xs12 sm12 md12>
                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium "> {{ $t('Discount') }} </span>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                      <v-switch :label="$t('Net-Discount-Account')" hide-details=""
                        v-model="BiletParametre.ParmetreIskonto.IskontoNet"></v-switch>
                      <v-switch :label="$t('Round-Up-Discount')" hide-details=""
                        v-model="BiletParametre.ParmetreIskonto.IskontoYukariYuvarla"></v-switch>
                      <v-switch :label="$t('Dont-Apply-Discount-Tickets-Card')"
                        v-model="BiletParametre.ParmetreIskonto.KrediKartliBiletIskontoYok" hide-details=""></v-switch>
                      <v-switch :label="$t('Dont-Apply-Discount-Domestic-Lines')"
                        v-model="BiletParametre.ParmetreIskonto.IcHatIskontoYok" hide-details=""></v-switch>
                      <v-switch :label="$t('Dont-Apply-Discount-International-Lines')"
                        v-model="BiletParametre.ParmetreIskonto.DisHatIskontoYok" hide-details=""></v-switch>
                      <v-switch :label="$t('Calculate-Discount-from-Service-Fee')" hide-details=""
                        v-model="BiletParametre.ParmetreIskonto.IskontoServisden"></v-switch>
                      <v-switch :label="$t('Dont-Apply-Discount-Commission-Tickets')" hide-details=""
                        v-model="BiletParametre.ParmetreIskonto.KomisyonsuzBiletIskontoYok"></v-switch>
                      <v-flex pt-2 xs12 sm12 md12>
                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium ">{{ $t('Credit-Card') }}</span>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                      <v-switch :label="$t('Amount-Discount-Tickets-Credit-Card')" hide-details=""
                        v-model="BiletParametre.ParametreKrediKart.BiletTahsilatIskontosuz"></v-switch>
                      <v-switch :label="$t('Close-Airline-B-A-Tickets-Credit Card')" hide-details=""
                        v-model="BiletParametre.ParametreKrediKart.HavayoluBorcAlacakKapat"></v-switch>
                      <v-switch :label="$t('Control-Total-Amount-Installment-Sales')"
                        v-model="BiletParametre.ParametreKrediKart.TaksitToplamTutarKonrtrolEtme" hide-details="">
                      </v-switch>
                      <v-switch :label="$t('POS-CODE-Required-Credit-Card-Sales')"
                        v-model="BiletParametre.ParametreKrediKart.PosKoduZorunlu" hide-details="">
                      </v-switch>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>




          </v-flex>

          <v-flex xs12 sm6 md3 pa-1>
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">{{ $t('Other') }}</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch :label="$t('Use-TR-ID-No-Detail')"
                      v-model="BiletParametre.ParametreDiger.AyrintiliTCKimlikKullan" hide-details="">
                    </v-switch>
                    <v-switch :label="$t('Use-Extra-Ticket-Description')"
                      v-model="BiletParametre.ParametreDiger.ExtraBiletAciklamaKullan" hide-details="">
                    </v-switch>
                    <v-switch :label="$t('Print-Single-Airline-Invoice')"
                      v-model="BiletParametre.ParametreDiger.FaturaTekHavayolu" hide-details="">
                    </v-switch>
                    <v-switch :label="$t('Expense-Center-Obligatory')" v-model="BiletParametre.ParametreDiger.MasrafZorunlu"
                      hide-details="">
                    </v-switch>

                    <v-switch :label="$t('Private-Firm-Reporting-Used')"
                      v-model="BiletParametre.ParametreDiger.OzelFirmaRaporlamaKullan" hide-details="">
                    </v-switch>

                    <v-switch :label="$t('MP-Working-Place')" hide-details=""
                      v-model="BiletParametre.ParametreDiger.MpCalismaYeri"></v-switch>

                    <v-switch :label="$t('Use Automatic Invoice')"
                      v-model="BiletParametre.ParametreDiger.OtomatikFaturaKullan" hide-details="">
                    </v-switch>
                    <v-switch :label="$t('Serial number entry is mandatory on the invoice')"
                      v-model="BiletParametre.ParametreDiger.FaturaSeriZorunlu" hide-details="">
                    </v-switch>
                    <v-switch :label="$t('Service Automatic')"
                      v-model="BiletParametre.ParametreDiger.ServisOtomatik" hide-details="">
                    </v-switch>
                    <v-select :items="yolcuAdiFormatItems" item-text="text" item-value="value"
                      v-model="BiletParametre.ParametreDiger.YolcuAdiFormat" label="Yolcu Adı Formatı"
                      hide-details="">
                    </v-select>
                    <v-btn flat="" color="info" @click="dialog = true" dark>{{ $t('Extra-Parameters') }}
                      <v-icon right dark>add</v-icon>
                    </v-btn>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>




<imagefiledialog ref="imagefiledialog" />



        </v-layout>

      </v-card>
    </v-form>

    <v-dialog v-model="dialog" scrollable="" persistent="" max-width="400px">
      <v-card color="grey lighten-5">
        <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row="" wrap="">
            <div class="flex md12">
              <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.UlkeKod" :label="$t('Country-Code')">
              </v-text-field>
              <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonSiparisNo"
                :label="$t('Last-Order-No')">
              </v-text-field>
              <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonDekontNo"
                :label="$t('Last-Receipt-No')">
              </v-text-field>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonFaturaSeri"
                  :label="$t('Last-Invoice-Serial')">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonFaturaNo" :label="$t('No')">
                </v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonProformaSeri"
                  :label="$t('Last-Proforma-Serial')">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonProformaNo"
                  :label="$t('No')">
                </v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEFaturaSeri"
                  :label="$t('Last-E-Invoice-Serial')">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEFaturaNo" :label="$t('No')">
                </v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEArsivNormalSeri"
                  :label="$t('Last-E-Archive-Serial-NS')">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEArsivNormalNo"
                  :label="$t('No')">
                </v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEarsivInternetSeri"
                  :label="$t('Last-E-Archive-Serial') + ' (IS)'">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEArsivInternetNo"
                  :label="$t('No')">
                </v-text-field>
              </v-layout>
            </div>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog=false"> {{ $t('OK') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="yuklenemediDialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="headline red white--text py-3">
          <v-icon color="white" class="mr-2">error_outline</v-icon>
          Hata
        </v-card-title>
        <v-card-text class="pt-4 body-1">
          Parametreler Yüklenemedi, Bir Süre Sonra Tekrar Deneyiniz..
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="yuklenemediKapat()">{{ $t('OK') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}

          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import imagefiledialog from "@/components/app/coper/comp/imagefiledialog.vue";

  export default {
    data() {
      return {
        PdfAyar: {
          tutarGoster: true,
          
        },
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        yolcuAdiFormatItems: [
          { text: 'Varsayılan', value: 0 },
          { text: 'Soyad/Ad', value: 1 },
          { text: 'Ad/Soyad', value: 2 },
        ],
        VergiParametre: {
                SirketKodu: 0,
                BiletKdv: 0,
                BiletDH: null,
                BiletAciklama: null,
                BiletDisp: false,

                PtaKdv: 0,
                PtaDH: null,
                PtaAciklama: null,
                PtaDisp: false,

                YffTutar: 0,
                YffKdv: 0,
                YffDH: null,
                YffAciklama: null,
                YffDisp: false,

                AlanVergisiTutar: 0,
                AlanVergisiKdv: 0,
                AlanVergisiDH: null,
                AlanVergisiAciklama: null,
                AlanVergisiDisp: false,

                Tax1Tutar: 0,
                Tax1Kdv: 0,
                Tax1DH: null,
                Tax1Aciklama: null,
                Tax1Disp: false,

                Tax2Tutar: 0,
                Tax2Kdv: 0,
                Tax2DH: null,
                Tax2Aciklama: null,
                Tax2Disp: false,

                Tax3Tutar: 0,
                Tax3Kdv: 0,
                Tax3DH: null,
                Tax3Aciklama: null,
                Tax3Disp: false,

                Tax4Tutar: 0,
                Tax4Kdv: 0,
                Tax4DH: null,
                Tax4Aciklama: null,
                Tax4Disp: false,

                DigerServisTutar: 0,
                DigerServisKdv: 0,
                DigerServisDH: null,
                DigerServisAciklama: null,
                DigerServisDisp: false,

                IcServisTutar: 0,
                IcServisKdv: 0,
                IcServisDH: null,
                IcServisAciklama: null,
                IcServisDisp: false,

                DisServisTutar: 0,
                DisServisKdv: 0,
                DisServisDH: null,
                DisServisAciklama: null,
                DisServisDisp: false,

                TekYonTutar: 0,
                TekYonKdv: 0,
                TekYonDH: null,
                TekYonAciklama: null,
                TekYonDisp: false,

                GDonusTutar: 0,
                GDonusKdv: 0,
                GDonusDH: null,
                GDonusAciklama: null,
                GDonusDisp: false,

                ReserveTutar: 0,
                ReserveKdv: 0,
                ReserveDH: null,
                ReserveAciklama: null,
                ReserveDisp: false,

                CezaTutar: 0,
                CezaKdv: 0,
                CezaDH: null,
                CezaAciklama: null,
                CezaDisp: false,

                ReserveDisHatKdv: false,
            },
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',

        BiletParametre: {
          ParametreGenel: {
            CharterKullaniyor: false,
            MuhasebeEntegre: false,
            MuhasebeSirket: null,
            HavayoluOlarakKullan: false,
            FaturaNoOtomatik: false,
            KisaFaturaDizayn: false,
            KurTarihiSatisTarihiKullan: false,
            SerbestFaturaDovizSatisKuru: false,
            FaturaBoyutParametre: false,
            BiletAlisFiyatKullan: false,
            BspTutarlariYuvarla: false,
            BspYuvarlaTaxaEkle: false,
            IadeBiletFaturala: false,
            FaturalanmisDegisklikYok: false,
            HavaYoluHesapSirketeGore: false,
            HyTutarServisSifirlama: false,
            CariAramaBos: false,
            FaturaOnayYok: false,
            DigerServisKontrol: false,
            ServisYuvarlamaYok: false,
            ThyTkmServisTutarYaz: false
          },
          ParametreCari: {
            HavayoluKomisyonDusulememisTutar: false,
            BaglantiliBiletCariHareketOlustur: false,
            CariHesapOtomatik: false,
            PesinBiletBakiyeSifir: false,
            IskontoCariyeAtma: false,
            HavayoluCariKesimTarih: false,
            BiletTutariServisli: false,
            BiletTutariDegiskenli: false,
            GetYesterdayCurrency:false,
            FaturaliBiletCariDegis: false,
            DekontServisAyri: false
          },
          ParametreKdv: {
            FaturaKdvAyir: false,
            DekontKdvAyir: false,
            PtaTutarKdvAyir: false,
            KdvYukariYuvarla: false,
            DipdenKdvHesapla: false,
            

          },
          ParametreKrediKart: {
            BiletTahsilatIskontosuz: false,
            HavayoluBorcAlacakKapat: false,
            TaksitToplamTutarKonrtrolEtme: false,
            PosKoduZorunlu: false
          },
          ParametreVade: {
            OdemeVadeTatilGunu: false,
            IadeVadeIadeTarihiKullan: false,
            IadeVadeHesapla: false
          },
          ParmetreIskonto: {
            ServisFarkiIskontoGoster: false,
            IskontoNet: false,
            IskontoYukariYuvarla: false,
            KrediKartliBiletIskontoYok: false,
            IcHatIskontoYok: false,
            DisHatIskontoYok: false,
            IskontoServisden: false,
            KomisyonsuzBiletIskontoYok: false
          },
          ParametreDiger: {
            SeturMuhasebeKontrol: false,
            AnalizKoduKullan: false,
            AyrintiliTCKimlikKullan: false,
            ExtraBiletAciklamaKullan: false,
            FaturaTekHavayolu: false,
            MasrafZorunlu: false,
            MerkezBankasiKurYok: false,
            OzelFirmaRaporlamaKullan: false,
            BiletDetayAnaEkran: false,
            FaturaSeriZorunlu: false,
            YolcuCrmKullan: false,
            MpCalismaYeri: false,
            BiletAyrinti: false,
            KrediBilgileri: false,
            FaturaMailKullan: false,
            TaksitKullan: false,
            OtomatikFaturaKullan: false,
            YeniVersiyonKontrolYok: false,
            BolumKoduZorunlu: false,
            TekSatirFaturaAdet: false,
            FaturaMasrafZorunlu: false,
            ServisOtomatik: false,
            ServisIcHatKodGetir: false,
            YolcuAdiFormat: 0,
          },
          ParametreSonFaturaBilgi: {
            UlkeKod: null,
            SonSiparisNo: null,
            SonDekontNo: null,
            SonFaturaSeri: null,
            SonFaturaNo: null,
            SonProformaSeri: null,
            SonProformaNo: null,
            SonEFaturaSeri: null,
            SonEFaturaNo: null,
            SonEArsivNormalSeri: null,
            SonEArsivNormalNo: null,
            SonEarsivInternetSeri: null,
            SonEArsivInternetNo: null
          }
        },

        BiletRaporParametre: {
          ParametrePath: {
            AmadeusPath: null,
            GalileoPath: null,
            TKIchatPath: null,
            AtlasPath: null,
            OnurAirPath: null,
            PegasusPath: null,
            YedekPath: null,
            XmlPath: null,
            WordSpanPath: null,
            SabrePath: null,
            PdfPath: null
          },
          ParametreFaturaDizayn: {
            IcHatFaturaMail: null,
            DisHatFaturaMail: null,
            IcHatFaturaPdf: null,
            DisHatFaturaPdf: null,
            IcHatFatura: null,
            IcHatDovizFatura: null,
            DisHatFatura: null,
            DisHatDovizFatura: null,
            CariHaraketFatura: null,
            FaturaBoy: null,
            FaturaEn: null,
            DekontBoy: null,
            DekontEn: null
          },
          ParametreCari: {
            IskontoHesap: null,
            AmadeusHesap: null
          },
          ParametreAktarim: {
            OptatBiletOtomatikAktar: false,
            ElektronikBiletOtomatikAktar: false,
            AtlasCashBiletKrediliAktar: false,
            TKIcHatOtomatikCariAktar: false,
            GalileoDisOtomatikCariAktar: false,
            AmadeusDisOtomatikCariAktar: false,
            AmadeusGalileoCariEslestirmeYok: false,
            AmadeusServisOlmasadaCariAktar: false,
            AtlasPegasusServisBileteEkle: false,
            PegasusSunExpressExBiletAktarma: false,
            SabreKurumsal: false,
            OfficeIdCariEslestirme: false
          },
          ParametreFatura: {
            FaturaAyriSeri: false,
            DekontKrediKartNo: false,
            DekontBiletAciklama: false,
            DekontBaslikYok: false,
            FaturaPdf: false,
            FirmaKartKontrol: false,
            DekontSirket: false
          },
          ParametreFaturaBaglanti: {
            KullaniciAdi: null,
            Sifre: null,
            Url: null
          }
        },

         FirmaParametre: {
          FirmaAdi: null,
          FirmaAdres: null,
          FirmaAdres2: null,
          BankaHesapNo: null,
          BankaSube: null,
          Tel1: null,
          Tel2: null,
          Tel3: null,
          Tel4: null,
          Tel5: null,
          VergiDaire: null,
          VergiNo: null,
          UlkeKod: null,
          UlkeIataKod: null,
          ParaBirimi: null,
          AcentaVatKod: null,
          SmsMusteriKod: null,
          SmsSifre: null,
          XmlSaticiKod: null
        },
        tumparametreler: [],
        dialog: false,
        yuklenemediDialog: false,
        parametreYuklendi: false,
        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      imagefiledialog
    },

  mounted() {

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

            this.BiletParametre=response.body.GenelParametre
            this.BiletRaporParametre=response.body.RaporParametre
            this.FirmaParametre=response.body.FirmaParametre

this.vergibilgigetir().then(() => {
  this.parametreYuklendi = true;
})
        }, () => {
          this.yuklenemediDialog = true;
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    methods: {
      yuklenemediKapat() {
        this.yuklenemediDialog = false;
        this.$router.go(-1);
      },
    LogoYukle() {
  this.$refs.imagefiledialog.open("PDF Logo Yükle", "PdfLogo").then((onay) => {
    if (onay) {
      if (this.$toast) {
        this.$toast.success("Logo başarıyla yüklendi.");
      } else {
        this.text1 = "Logo başarıyla yüklendi";
        this.snackbar = true;
      }
    }
  }).catch(() => {
    if (this.$toast) {
      this.$toast.error("Logo yüklenemedi.");
    } else {
      this.text1 = "Logo yüklenemedi";
      this.snackbar = true;
    }
  });
},

      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      onChange: onChange,
      getDateNow: getDateNow,
      toDateformat: toDateformat,
      Kaydet: Kaydet,
      vergibilgigetir:vergibilgigetir,
      vergikaydetkapat:vergikaydetkapat
    },
  }
  function vergibilgigetir() {

var credentials = JSON.parse(window.localStorage.getItem('credentials'));
var params = {
    CompanyCode: credentials.SirketKodu
}

return this.$http.post(auth.API_URL + 'api/TicketParametre/TicketTaxParametreGet', params, {
    headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
}).then((response) => {
    this.VergiParametre = response.body
}, (response) => {
    if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
    } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
    }
})




}
function vergikaydetkapat() {

var credentials = JSON.parse(window.localStorage.getItem('credentials'));

this.VergiParametre.SirketKod = credentials.SirketKodu;

var params = this.VergiParametre;

this.$http.post(auth.API_URL + 'api/TicketParametre/TicketTaxParametreAdd', params, {
    headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
}).then((response) => {

   

}, (response) => {
    if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

    } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

    }
})

}
  function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      GenelParametre: this.BiletParametre,
      RaporParametre: this.BiletRaporParametre,//this.tumparametreler.RaporParametre,
      FirmaParametre: this.FirmaParametre,//this.tumparametreler.FirmaParametre,
      SirketKodu: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

       this.text1 = this.$t(response.body.ResponseMessage)
       this.snackbar = true
       this.vergikaydetkapat();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }



  function beforeMount() {

  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      this.date = b
    } else {
      this.dateFormatted = null
    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '-' + mm + '-' + yyyy
    return today
  }
</script>
<style>
</style>